module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-cerita-08.1faaba5c.jpg";